/**
 * UploadDocumentDialog - Main export
 * Exports the refactored implementation directly
 */

'use client';

export { UploadDocumentDialog } from './upload-document-dialog-impl';
export type { UploadDocumentDialogProps } from './upload-document-dialog-impl';
